import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { device } from '../../styles/responsive';

const SocialContainer = styled(motion.div)`
  position: fixed;
  left: 20px;
  top: 45%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 10;
  
  @media ${device.md} {
    display: none; /* Hide on mobile - moved to hamburger menu */
  }
`;

const SocialLink = styled(motion.a)`
  color: white;
  font-size: 20px;
  opacity: 0.8;
  transition: all 0.3s;
  cursor: pointer;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(7, 205, 205, 0.05);
  border: 1px solid rgba(7, 205, 205, 0.2);
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  width: 45px;
  height: 45px;
  
  @media ${device.md} {
    width: 40px;
    height: 40px;
    font-size: 18px;
    padding: 10px;
  }
  
  @media ${device.sm} {
    width: 36px;
    height: 36px;
    font-size: 16px;
    padding: 8px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
      circle at center,
      rgba(7, 205, 205, 0.1) 0%,
      transparent 70%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    opacity: 1;
    color: #07CDCD;
    transform: translateY(-3px);
    border-color: rgba(7, 205, 205, 0.4);
    box-shadow: 0 5px 15px rgba(7, 205, 205, 0.1);

    &::before {
      opacity: 1;
    }
  }
`;

const SocialLinks = () => {
  return (
    <SocialContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1.2 }}
    >
      <SocialLink
        href="https://github.com/MQZakir"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <FontAwesomeIcon icon={faGithub} />
      </SocialLink>
      <SocialLink
        href="https://linkedin.com/in/MQZakir"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </SocialLink>
    </SocialContainer>
  );
};

export default SocialLinks; 